import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FullscreenLoadingOverlayService } from './fullscreen-loading-overlay.service';
import { EpdkLoadingDialogComponent } from './loading-dialog.component';

@NgModule({
  imports: [
    CommonModule,

    // Angular Material.
    MatDialogModule,
    MatProgressSpinnerModule,
  ],
  declarations: [EpdkLoadingDialogComponent],
  providers: [FullscreenLoadingOverlayService]
})
export class FullscreenLoadingOverlayServiceModule { }
